module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vlymp6-8c2d3617c857ecbd9f3c4b9f4fe52adb.jpg";